import { useRef } from 'react'

export function updateQuerystringParams(object) {
  if (window.URLSearchParams && window.history?.replaceState) {
    const params = new URLSearchParams(window.location.search)

    Object.entries(object).forEach(([key, value]) => {
      if (value == null) {
        params.delete(key)
      } else {
        params.set(key, value)
      }
    })

    window.history.replaceState(
      {},
      '',
      `${window.location.pathname}?${params.toString()}`
    )
  }
}

// Update the URL if browser supports it
export function updateQuerystringParam(key, value) {
  updateQuerystringParams({ key, value })
}

export function getQueryStringValue(key) {
  // Bail out if browser doesn't support URLSearchParams
  if (!window.URLSearchParams) {
    return undefined
  }

  const params = new URLSearchParams(window.location.search)

  return params.get(key)
}

// Hook to update the URL when the state changes
export function useLocationStore(state, selector = s => s) {
  const previusStateRef = useRef(null)

  const { current: previusState } = previusStateRef
  const currentState = selector(state)

  // We always have to track current state, even when there is no previous state
  previusStateRef.current = currentState

  // No previous state, bail out. We don't want to update the URL with the initial state
  if (previusState === null) {
    return null
  }

  const updates = {}
  Object.entries(currentState).forEach(([key, value]) => {
    if (value !== previusState[key]) {
      updates[key] = value
    }
  })

  updateQuerystringParams(updates)
}
